export default {"src":"/_next/static/media/avatar.c9441dc8.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};